import { Component, OnInit } from '@angular/core';
import { CommonService } from "src/app/shared/services/common.service";
import { MigrationJsonsService } from "src/app/shared/services/migration-jsons.service";

@Component({
    selector: 'app-migration-jsons',
    templateUrl: './migration-jsons.component.html',
    styleUrls: ['./migration-jsons.component.scss'],
    standalone: false
})
export class MigrationJsonsComponent implements OnInit {

  screenCreatorData: any = [];

  constructor(private commonService: CommonService, private migrationJsonsService: MigrationJsonsService) { }

  async ngOnInit() {

    let screenCreatorDataMaster: any = [];

    screenCreatorDataMaster = await this.commonService.retrieveSingleRecordService("screencreator", "parentLevel", "Masters");

    let screenCreatorDataSetup: any = [];

    screenCreatorDataSetup = await this.commonService.retrieveSingleRecordService("screenCreator", "parentlevel", "Setup");

    console.log(screenCreatorDataMaster);

    console.log(screenCreatorDataSetup);

    screenCreatorDataMaster.filter(screenCreatorDataMasterTemporary => {

      this.screenCreatorData.push(screenCreatorDataMasterTemporary);

    });

    screenCreatorDataSetup.filter(screenCreatorDataSetupTemporary => {

      this.screenCreatorData.push(screenCreatorDataSetupTemporary);

    });

    console.log(this.screenCreatorData);

  }

  async migrateJsons() {

    console.log(this.screenCreatorData);

    let columnTypes = { "valuePrimaryKey": "Integer Number", "valueInteger": "Integer Number", "valueDecimal": "Decimal Number", "valueText": "Free Text Single line", "valueTextArea": "Free Text Multi line", "valueEmail": "Email", "valuePassword": "Password", "valueFileName": "Free Text Single line", "valueFilePath": "Attachment", "valueParentDropDown": "Linked Fields", "valueDropDown": "Linked Fields", "valueDate": "DatePicker", "valueStartDate": "Start & End Date", "valueEndDate": "Start & End Date", "valueDateTime": "DateTimePicker", "valueStartDateTime": "Start & End Date Time", "valueEndDateTime": "Start & End Date Time", "valueCheckbox": "Checkbox", "valueRadio": "Radio", "valueSelectListStatic": "Select List - Static" };

    this.screenCreatorData.filter(screenCreatorDataTemporary => {

      screenCreatorDataTemporary["screenId"] = screenCreatorDataTemporary["childScreenId"];

      let tableJson = {};

      tableJson["colSpan"] = JSON.parse(screenCreatorDataTemporary.tableJson).colSpan;

      tableJson["tableID"] = JSON.parse(screenCreatorDataTemporary.tableJson).tableID;

      let tableData = JSON.parse(screenCreatorDataTemporary.tableJson).tableData;

      let tableDataArray = [];

      console.log(tableData);

      tableData.filter(tableDataTemporary => {

        let tableDataSingleJson = {};

        //keysOfTDT is keysOfTableDataTemporary.
        let keysOfTDT: any = [];

        keysOfTDT = Object.keys(tableDataTemporary);

        if (keysOfTDT.indexOf("columnType") >= 0) {

          tableDataSingleJson["fieldType"] = columnTypes[tableDataTemporary["columnType"]];

        }

        if (keysOfTDT.indexOf("columnName") >= 0) {

          tableDataSingleJson["fieldName"] = tableDataTemporary["columnName"];

        }

        if (keysOfTDT.indexOf("displayFormColumnName") >= 0) {

          tableDataSingleJson["formName"] = tableDataTemporary["displayFormColumnName"];

        }

        if (keysOfTDT.indexOf("formColumnShow") >= 0) {

          tableDataSingleJson["showForm"] = tableDataTemporary["formColumnShow"];

        }

        if (keysOfTDT.indexOf("displayAgGridColumnName") >= 0) {

          tableDataSingleJson["agGridColumnName"] = tableDataTemporary["displayAgGridColumnName"];
        }

        if (keysOfTDT.indexOf("agGridColumnShow") >= 0) {

          tableDataSingleJson["showinGrid"] = tableDataTemporary["agGridColumnShow"];

        }

        if (keysOfTDT.indexOf("isRequired") >= 0) {

          tableDataSingleJson["mandatory"] = tableDataTemporary["isRequired"];

        }

        if (keysOfTDT.indexOf("isUnique") >= 0) {

          tableDataSingleJson["uniqueField"] = tableDataTemporary["isUnique"];

        }

        if (keysOfTDT.indexOf("dataType") >= 0) {

          tableDataSingleJson["dataType"] = tableDataTemporary["dataType"];

        }

        if (keysOfTDT.indexOf("maximumLength") >= 0) {

          tableDataSingleJson["maxLength"] = tableDataTemporary["maximumLength"];

        }

        if (keysOfTDT.indexOf("radioValues") >= 0) {

          let radioValuesArray = tableDataTemporary["radioValues"].split(",");

          tableDataSingleJson["radioValue1"] = radioValuesArray[0];

          tableDataSingleJson["radioValue2"] = radioValuesArray[1];

          if (radioValuesArray.length == 3) {

            tableDataSingleJson["radioValue3"] = radioValuesArray[2];

          }

        }

        if (keysOfTDT.indexOf("startDateName") >= 0) {

          tableDataSingleJson["startDateName"] = tableDataTemporary["startDateName"];

        }

        if (keysOfTDT.indexOf("endDateName") >= 0) {

          tableDataSingleJson["endDateName"] = tableDataTemporary["endDateName"];

        }

        if (keysOfTDT.indexOf("startDateTimeName") >= 0) {

          tableDataSingleJson["startDateTimeName"] = tableDataTemporary["startDateTimeName"];

        }

        if (keysOfTDT.indexOf("endDateTimeName") >= 0) {

          tableDataSingleJson["endDateTimeName"] = tableDataTemporary["endDateTimeName"];

        }

        if (keysOfTDT.indexOf("dropdownLookupType") >= 0) {

          tableDataSingleJson["lookupTableName"] = tableDataTemporary["dropdownLookupType"];

        }

        if (keysOfTDT.indexOf("dropDownTableName") >= 0) {

          tableDataSingleJson["dropDownTableName"] = tableDataTemporary["dropDownTableName"];

        }

        if (keysOfTDT.indexOf("dropDownIDs") >= 0) {

          tableDataSingleJson["dropDownIDs"] = tableDataTemporary["dropDownIDs"];

        }

        if (keysOfTDT.indexOf("dropDownValues") >= 0) {

          tableDataSingleJson["dropDownValues"] = tableDataTemporary["dropDownValues"];

        }

        if (keysOfTDT.indexOf("dropDownChildFieldName") >= 0) {

          tableDataSingleJson["dropDownChildFieldName"] = tableDataTemporary["dropDownChildFieldName"];

        }

        if (keysOfTDT.indexOf("imageName") >= 0) {

          tableDataSingleJson["maxLength"] = tableDataTemporary["imageName"];

        }

        if (keysOfTDT.indexOf("maximumValue") >= 0) {

          tableDataSingleJson["maxValuee"] = tableDataTemporary["maximumValue"];

        }

        if (keysOfTDT.indexOf("maximumDecimalValue") >= 0) {

          tableDataSingleJson["maxValuee"] = tableDataTemporary["maximumDecimalValue"];

        }

        if (keysOfTDT.indexOf("maximumDate") >= 0) {

          tableDataSingleJson["maxValuee"] = tableDataTemporary["maximumDate"];

        }

        if (keysOfTDT.indexOf("maximumDateTime") >= 0) {

          tableDataSingleJson["maxValuee"] = tableDataTemporary["maximumDateTime"];

        }

        tableDataArray.push(tableDataSingleJson);

      });

      tableJson["tableData"] = tableDataArray;

      console.log(tableDataArray);

      tableJson["tableName"] = JSON.parse(screenCreatorDataTemporary.tableJson).tableName;

      screenCreatorDataTemporary.tableJson = JSON.stringify(tableJson);

    });

    console.log(this.screenCreatorData);

    await this.migrationJsonsService.insertService(this.screenCreatorData);

  }

}